export default {
  viewBox: "0 0 24 24",
  html: "<path fill-rule=\"evenodd\" d=\"M18 4V2h-2v2H8V2H6v2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm1 16H5V9h14M9.68 19.492l5.428-5.144-2.171-.79 1.474-4.05-5.518 5.11 2.26.823z\"/>"
};